interface RuntimeConfig {
  cognitoDomain: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  o365IdpName: string;
  publicOrigin: string;
  apiPathPrefix: string;
}

let cachedConfig: RuntimeConfig | null = null;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cachedConfig) return cachedConfig;
  const resp = await fetch("/config.json", { cache: "no-store" });
  if (!resp.ok) throw new Error(`Failed to load /config.json: ${resp.status}`);
  cachedConfig = (await resp.json()) as RuntimeConfig;
  return cachedConfig;
}

export function getConfig(): RuntimeConfig {
  if (!cachedConfig) throw new Error("Config not yet loaded. Call loadConfig() first.");
  return cachedConfig;
}
